export const GET_ALL_PAGE_WORKS = "GET_ALL_PAGE_WORKS";
export const GET_ALL_PAGE_WORKS_SUCCESS = "GET_ALL_PAGE_WORKS_SUCCESS";
export const GET_ALL_PAGE_WORKS_FAILURE = "GET_ALL_PAGE_WORKS_FAILURE";

export const GET_WORK = "GET_WORK";
export const GET_WORK_SUCCESS = "GET_WORK_SUCCESS";
export const GET_WORK_FAILURE = "GET_WORK_FAILURE";

export const EDIT_WORK = "EDIT_WORK";
export const EDIT_WORK_SUCCESS = "EDIT_WORK_SUCCESS";
export const EDIT_WORK_FAILURE = "EDIT_WORK_FAILURE";

export const ADD_WORK = "ADD_WORK";
export const ADD_WORK_SUCCESS = "ADD_WORK_SUCCESS";
export const ADD_WORK_FAILURE = "ADD_WORK_FAILURE";

export const DELETE_WORK = "DELETE_WORK";
export const DELETE_WORK_SUCCESS = "DELETE_WORK_SUCCESS";
export const DELETE_WORK_FAILURE = "DELETE_WORK_FAILURE";

export const EDIT_PAGE_WORK = "EDIT_PAGE_WORK";
export const EDIT_PAGE_WORK_SUCCESS = "EDIT_PAGE_WORK_SUCCESS";
export const EDIT_PAGE_WORK_FAILURE = "EDIT_PAGE_WORK_FAILURE";
